import { memo1, isBrowser, onDomReady, injectScript, isLocalhost, isLocalhostTrackingEnabled, hashUserData, scriptExists, flatten1, pipe } from '@csod/tracker-common';

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var resolveWithState = function resolveWithState(state, data) {
  var newData = data;

  if (data) {
    if (typeof data === 'function') {
      newData = data(state);
    } else {
      newData = Object.keys(data).reduce(function (acc, k) {
        var getData = data[k];
        acc[k] = typeof data[k] === 'function' ? getData(state) : getData;
        return acc;
      }, {});
    }
  }

  return newData;
};

var resolveToTrackAction = function resolveToTrackAction(getActionCreators) {
  return function (action, state) {
    var _getActionCreators = getActionCreators(),
        track = _getActionCreators.track;

    var payload = action.payload;
    var newPayload;

    if (!payload) {
      return track(payload);
    }

    if (typeof payload === 'function') {
      newPayload = payload(state);
    } else {
      var userData = payload.userData,
          eventData = payload.eventData,
          rest = _objectWithoutPropertiesLoose(payload, ["userData", "eventData"]);

      newPayload = _objectSpread({}, rest, {
        userData: resolveWithState(state, userData),
        eventData: resolveWithState(state, eventData)
      });
    }

    return track(newPayload);
  };
};

function getActionCreators(vendorKey) {
  var prefix = "[" + vendorKey + "]";
  var ac = {
    prefix: prefix,
    // command action types
    LOAD: prefix + " LOAD",
    INIT: prefix + " INIT",
    TRACK: prefix + " TRACK",
    TRACK_WITH_STATE: prefix + " TRACK_WITH_STATE",
    PAUSE_TRACKING: prefix + " PAUSE_TRACKING",
    RESUME_TRACKING: prefix + " RESUME_TRACKING",
    TERMINATE_USER_SESSION: prefix + " TERMINATE_USER_SESSION",
    load: function load() {
      return {
        type: ac.LOAD
      };
    },
    init: function init(payload) {
      return {
        type: ac.INIT,
        payload: payload
      };
    },
    track: function track(payload) {
      return {
        type: ac.TRACK,
        payload: payload
      };
    },
    trackWithState: function trackWithState(payload) {
      return {
        type: ac.TRACK_WITH_STATE,
        payload: payload
      };
    },
    pauseTracking: function pauseTracking() {
      return {
        type: ac.PAUSE_TRACKING
      };
    },
    resumeTracking: function resumeTracking() {
      return {
        type: ac.RESUME_TRACKING
      };
    },
    terminateSession: function terminateSession() {
      return {
        type: ac.TERMINATE_USER_SESSION
      };
    },
    internal: getInternalActionCreators(prefix, function () {
      return ac;
    })
  };
  return ac;
}

function getInternalActionCreators(prefix, getActionCreators) {
  var ac = {
    // command action types
    DISPATCH_PENDING_ACTIONS: prefix + " DISPATCH_PENDING_ACTIONS",
    // event action types
    LOAD_DONE: prefix + " LOAD_DONE",
    INIT_DONE: prefix + " INIT_DONE",
    INIT_ERR: prefix + " INIT_ERR",
    TRACK_DONE: prefix + " TRACK_DONE",
    TRACK_ERR: prefix + " TRACK_ERR",
    // BUFFERED_ACTIONS: `${prefix} BUFFERED_ACTIONS`,
    // document action types
    SET_PENDING_ACTION: prefix + " SET_PENDING_ACTION",
    loadDone: function loadDone() {
      return {
        type: ac.LOAD_DONE
      };
    },
    initDone: function initDone() {
      return {
        type: ac.INIT_DONE
      };
    },
    initFail: function initFail(err) {
      return {
        type: ac.INIT_ERR,
        payload: err
      };
    },
    trackDone: function trackDone(meta) {
      return {
        type: ac.TRACK_DONE,
        meta: meta
      };
    },
    trackFail: function trackFail(meta, err) {
      return {
        type: ac.TRACK_ERR,
        payload: err,
        meta: meta
      };
    },
    dispatchPendingActions: function dispatchPendingActions() {
      return {
        type: ac.DISPATCH_PENDING_ACTIONS
      };
    },
    setPendingAction: function setPendingAction(action) {
      return {
        type: ac.SET_PENDING_ACTION,
        meta: action
      };
    },

    /*
    bufferedActions: actions => ({
      type: ac.BUFFERED_ACTIONS,
      meta: actions
    }),
    */
    resolveToTrackAction: resolveToTrackAction(getActionCreators)
  };
  return ac;
}

var memod = memo1(getActionCreators);

var relayActionsDefault = {
  TRACK_ANALYTICS: true,
  PAUSE_ANALYTICS_TRACKING: true,
  RESUME_ANALYTICS_TRACKING: true,
  TERMINATE_ANALYTICS_USER_SESSION: true,
  LOAD_ANALYTICS_DONE: true,
  INIT_ANALYTICS_DONE: true,
  INIT_ANALYTICS_ERR: true,
  TRACK_ANALYTICS_DONE: true,
  TRACK_ANALYTICS_ERR: true,
  SET_PENDING_ANALYTICS_ACTION: true
};
function createFilterMiddleware(appSettings, ac) {
  var _appSettings$relayAct = appSettings.relayActions,
      relayActions = _appSettings$relayAct === void 0 ? {} : _appSettings$relayAct;
  var prefix = ac.prefix;
  var actionKeyChecks = {};

  if (typeof relayActions === 'boolean') {
    // relay all => no need to apply filter middleware
    if (relayActions) return; // ows block all by default checks = {}
  } else {
    actionKeyChecks = _objectSpread({}, relayActionsDefault, relayActions);
  }

  var checks = transformActionKeys(ac, actionKeyChecks);
  var relayFn = relay.bind(null, prefix, checks);
  return function (store) {
    return function (next) {
      return function (action) {
        return relayFn(action) && next(action);
      };
    };
  };
}

function transformActionKeys(ac, checks) {
  var res = Object.keys(checks).reduce(function (acc, key) {
    if (ac.hasOwnProperty(key)) {
      // @ts-ignore
      acc[ac[key]] = checks[key];
    } else if (ac.internal.hasOwnProperty(key)) {
      // @ts-ignore
      acc[ac.internal[key]] = checks[key];
    }

    return acc;
  }, {});
  return res;
}

function relay(prefix, checks, action) {
  if (!action || !action.type || action.type.indexOf(prefix) !== 0) return true;
  return !!checks[action.type];
}

var Client =
/*#__PURE__*/
function () {
  function Client(appSettings, VendorAPI, ac) {
    _defineProperty(this, "_times", {});

    _defineProperty(this, "_pendingActions", new Set());

    _defineProperty(this, "_vendorAPI", void 0);

    _defineProperty(this, "_appSettings", void 0);

    _defineProperty(this, "_allScripts", void 0);

    _defineProperty(this, "_ac", void 0);

    var env = appSettings.env;
    this._vendorAPI = new VendorAPI(env);
    this._appSettings = appSettings;
    this._allScripts = VendorAPI.scripts;
    this._ac = ac;
    this._times.created = new Date().getTime();
  }

  var _proto = Client.prototype;

  _proto.scheduleLoadDispatch = function scheduleLoadDispatch() {
    var _this = this;

    var preventAutoLoadInit = this._appSettings.preventAutoLoadInit;
    return new Promise(function (resolve, reject) {
      if (!_this.loadInvoked && !preventAutoLoadInit && isBrowser) {
        onDomReady().then(function () {
          return !_this.loadInvoked ? resolve() : reject();
        }, function () {
          return reject();
        });
      } else {
        reject();
      }
    }).then(this._ac.load);
  };

  _proto.load = function load() {
    if (this.loadInvoked) return Promise.reject(new Error('Load already called.'));
    this._times.loadStart = new Date().getTime();
    var getScript = this._vendorAPI.getScript;
    var loadDone = this._ac.internal.loadDone;
    if (this.loadCompleted) return Promise.resolve(loadDone());
    return Promise.all(getScript().map(injectScript)).then(loadDone);
  };

  _proto.loadDone = function loadDone() {
    this._times.loadEnd = new Date().getTime();
  };

  _proto.init = function init(action) {
    var _this$_ac$internal = this._ac.internal,
        setPendingAction = _this$_ac$internal.setPendingAction,
        initDone = _this$_ac$internal.initDone,
        initFail = _this$_ac$internal.initFail; // check if not loaded, add action to processing queue .. needed?

    if (!this.loadCompleted) return Promise.resolve(setPendingAction(action));
    this._times.initStart = new Date().getTime();
    return this._vendorAPI.init(action.payload).then(initDone, function () {
      return initFail(new Error('Could not call init on undefined instance.'));
    });
  };

  _proto.initDone = function initDone() {
    this._times.initEnd = new Date().getTime();
    var _this$_ac = this._ac,
        pauseTracking = _this$_ac.pauseTracking,
        resumeTracking = _this$_ac.resumeTracking;
    return Promise.resolve(isLocalhost && (!isLocalhostTrackingEnabled() ? pauseTracking() : resumeTracking()));
  };

  _proto.savePendingAction = function savePendingAction(action) {
    this._pendingActions.add(action);
  };

  _proto.dispatchPendingActions = function dispatchPendingActions() {
    if (!this.initCompleted) return Promise.resolve(null);
    var actions = [];

    this._pendingActions.forEach(function (action) {
      return actions.push(action);
    });

    this._pendingActions.clear();

    return Promise.resolve(actions);
  };

  _proto.track = function track(action) {
    var _this2 = this;

    var _this$_ac$internal2 = this._ac.internal,
        setPendingAction = _this$_ac$internal2.setPendingAction,
        trackDone = _this$_ac$internal2.trackDone,
        trackFail = _this$_ac$internal2.trackFail; // check if not initialized, add action to processing queue

    if (!this.initCompleted) return Promise.resolve(setPendingAction(action));
    var anonymizeUserData = this._appSettings.anonymizeUserData;
    var _action$payload = action.payload,
        userData = _action$payload.userData,
        eventData = _action$payload.eventData;
    var res;

    if (userData) {
      // anonymize userData based on anonymizeUserData
      res = hashUserData(userData, anonymizeUserData).then(function (userData) {
        return _this2._vendorAPI.track(userData, eventData).then(function () {
          return userData;
        });
      }).then(function (userData) {
        return userData !== action.payload.userData ? trackDone({
          action: action,
          anonymizedUserData: true
        }) : trackDone({
          action: action
        });
      });
    } else {
      res = this._vendorAPI.track(userData, eventData).then(function () {
        return trackDone({
          action: action
        });
      });
    }

    return res.catch(function (err) {
      return trackFail({
        action: action
      }, err || new Error("Could not send track action."));
    });
  };

  _proto.controlTracking = function controlTracking(value) {
    this._vendorAPI.controlTracking(value);
  };

  _proto.terminateSession = function terminateSession() {
    this._vendorAPI.terminateSession();
  };

  _createClass(Client, [{
    key: "loadInvoked",
    get: function get() {
      return typeof this._times.loadStart !== 'undefined';
    }
  }, {
    key: "loadCompletedExternally",
    get: function get() {
      var getInstance = this._vendorAPI.getInstance;
      return getInstance() || scriptExists(this._allScripts);
    }
  }, {
    key: "loadCompleted",
    get: function get() {
      return typeof this._times.loadEnd !== 'undefined' || this.loadCompletedExternally;
    }
  }, {
    key: "initCompleted",
    get: function get() {
      return typeof this._times.initEnd !== 'undefined';
    }
  }]);

  return Client;
}();

var DispatchBuffer = function DispatchBuffer() {
  var _this = this;

  _defineProperty(this, "_pactions", []);

  _defineProperty(this, "bufferActions", function () {
    var _this$_pactions;

    return (_this$_pactions = _this._pactions).push.apply(_this$_pactions, arguments);
  });

  _defineProperty(this, "reset", function () {
    return _this._pactions = [];
  });

  _defineProperty(this, "resolveBufferedActions", function () {
    var pactions = _this._pactions;

    _this.reset();

    if (pactions.length == 0) return Promise.resolve([]);
    return Promise.all(pactions).then(function (actions) {
      return flatten1(actions);
    }).then(function (actions) {
      return actions.filter(Boolean);
    });
  });
};

function createTrackerMiddleware(appSettings, API, getAPIOptions, ac) {
  var init = ac.init,
      LOAD = ac.LOAD,
      INIT = ac.INIT,
      TRACK = ac.TRACK,
      TRACK_WITH_STATE = ac.TRACK_WITH_STATE,
      PAUSE_TRACKING = ac.PAUSE_TRACKING,
      RESUME_TRACKING = ac.RESUME_TRACKING,
      TERMINATE_USER_SESSION = ac.TERMINATE_USER_SESSION,
      prefix = ac.prefix;
  var _ac$internal = ac.internal,
      resolveToTrackAction = _ac$internal.resolveToTrackAction,
      LOAD_DONE = _ac$internal.LOAD_DONE,
      dispatchPendingActions = _ac$internal.dispatchPendingActions,
      DISPATCH_PENDING_ACTIONS = _ac$internal.DISPATCH_PENDING_ACTIONS,
      SET_PENDING_ACTION = _ac$internal.SET_PENDING_ACTION,
      INIT_DONE = _ac$internal.INIT_DONE;

  var _client = new Client(appSettings, API, ac);

  return function (store) {
    _client.scheduleLoadDispatch().then(store.dispatch, function () {});

    var _ref = new DispatchBuffer(),
        bufferActions = _ref.bufferActions,
        resolveBufferedActions = _ref.resolveBufferedActions;

    return function (next) {
      return function (action) {
        if (!action || !action.type || action.type.indexOf(prefix) !== 0) return next(action);

        if (action.type === LOAD) {
          bufferActions(_client.load());
        } else if (action.type === LOAD_DONE) {
          _client.loadDone();

          var initDispatchPromise = getAPIOptions(store).then(function (apiOptions) {
            return apiOptions && init(apiOptions);
          }, function () {
            return null;
          });
          bufferActions(initDispatchPromise);
        } else if (action.type === INIT) {
          bufferActions(_client.init(action));
        } else if (action.type === INIT_DONE) {
          bufferActions(_client.initDone(), Promise.resolve(dispatchPendingActions()));
        } else if (action.type === DISPATCH_PENDING_ACTIONS) {
          bufferActions(_client.dispatchPendingActions());
        } else if (action.type === SET_PENDING_ACTION) {
          _client.savePendingAction(action.meta);
        } else if (action.type === TRACK) {
          bufferActions(_client.track(action));
        } else if (action.type === TRACK_WITH_STATE) {
          var resolved = resolveToTrackAction(action, store.getState());
          bufferActions(Promise.resolve(resolved));
        } else if (action.type === PAUSE_TRACKING) {
          _client.controlTracking(true);
        } else if (action.type === RESUME_TRACKING) {
          _client.controlTracking(false);
        } else if (action.type === TERMINATE_USER_SESSION) {
          _client.terminateSession();
        }

        resolveBufferedActions().then(function (actions) {
          if (!actions.some(function (action) {
            return action.type === SET_PENDING_ACTION;
          })) {
            next(action);
          }

          actions.forEach(function (a) {
            return store.dispatch(a);
          });
        });
      };
    };
  };
}

function createTrackerStoreEnhancer(appSettings, API, getAPIOptions) {
  var ac = memod(API.vendorKey);
  var middlewares = [createFilterMiddleware(appSettings, ac), createTrackerMiddleware(appSettings, API, getAPIOptions, ac)].filter(Boolean);
  return function (createStore) {
    return function (reducer, initialState) {
      for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }

      var store = createStore.apply(void 0, [reducer, initialState].concat(args));

      var _dispatch = function dispatch(action) {
        return void 0;
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      var pipeline = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = pipe.apply(void 0, pipeline)(store.dispatch);
      return _objectSpread({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

export { createTrackerStoreEnhancer, memod as getActionCreators };



//////////////////
// WEBPACK FOOTER
// ../@csod/tracker/build/index.js
// module id = 272
// module chunks = 0